import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import styles from "../../styles/pages/superadmin/message-details.module.scss";
// import styles from "../../styles/pages/mymessage.module.scss";
import "react-perfect-scrollbar/dist/css/styles.css";
import { getCookie } from "../../lib/functions/storage.lib";
import { getStyledDateTime } from "../../lib/functions/utils.lib";
import ExpandSmMinusIcon from "../../public/assets/icons/ExpandSmMinusIcon";
import ExpandSmPlusIcon from "../../public/assets/icons/ExpandSmPlusIcon";

const AgentTagList = (props) => {
  const userCookie = getCookie("userdetails");
  const user = JSON.parse(userCookie ? userCookie : "{}");
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      {props?.initiated?.name === `${user.name} ${user.last_name}` ? (
        <Box className={`${styles.msgdetails} ${styles.agentTag}`}>
          <Typography variant="h6">
            <span>I</span> started this convo.
          </Typography>
          <Typography variant="h6">
            <span>{props.recipent?.name}</span> (
            {props?.recipent?.role?.display_name}) is the recipent.
          </Typography>
        </Box>
      ) : props?.admin_joined ? (
        <Box
          className={`${styles.msgdetails} ${styles.agentTag} ${styles.convoCard}`}
        >
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              expandIcon={expanded === 'panel1' ? <ExpandSmMinusIcon /> :<ExpandSmPlusIcon /> }
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography variant="caption">In this convo:</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2">
                <strong>{props.initiated?.name}</strong> (
                {props?.initiated?.role?.display_name}) started this convo.
              </Typography>
              <Typography variant="body2">
                <strong>{props.recipent?.name}</strong> (
                {props?.recipent?.role?.display_name}) is the recipent.
              </Typography>
              <Typography variant="body2">
                <strong>I joined this convo</strong> at{" "}
                {getStyledDateTime(props.admin_joined_at)}.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      ) : (
        <Box className={`${styles.msgdetails} ${styles.agentTag}`}>
          <Typography variant="h6">
            <span>{props.initiated?.name}</span> (
            {props?.initiated?.role?.display_name}) started this convo.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default AgentTagList;
